import React from 'react';
import { Link } from 'react-router';
import './Menu.css';

export default function Menu() {
  return (
    <div className='menu'>
      <input id='menu__toggle' type='checkbox' />
      <label class='menu__btn' for='menu__toggle'>
        <span></span>
      </label>

      <ul class='menu__box'>
        <li>
          <Link
            to='/'
            class='menu__item'
            id='menu__item__home'
          >
            Home
          </Link>
        </li>
        {/* <li>
          <Link
            to='/books'
            class='menu__item'
            id='menu__item__books'
          >
            Books
          </Link>
        </li> */}
        <li>
          <Link
            to='/about'
            class='menu__item'
            id='menu__item__about'
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to='/contact'
            class='menu__item'
            id='menu__item__contact'
          >
            Contact
          </Link>
        </li>
      </ul>
    </div>
  )
}
